




<mat-grid-list cols="3">
    <mat-grid-tile>
        <mat-card class="home-card" [routerLink]="'/#/dashboard'">
            <mat-card-header>
                <i mat-card-avatar class="icon-graph"></i>
                <mat-card-title>Dashboard</mat-card-title>
                <mat-card-subtitle>SproutScribe Overview</mat-card-subtitle>
            </mat-card-header>
            <mat-card-content>
                <p>
                    View SproutScribe overview and usage statistics.
                </p>
            </mat-card-content>
        </mat-card>
    </mat-grid-tile>
    <mat-grid-tile>
        <mat-card class="home-card" [routerLink]="'/design/import'">
            <mat-card-header>
                <i mat-card-avatar class="icon-cloud-upload"></i>
                <mat-card-title>Import Form</mat-card-title>
                <mat-card-subtitle class="home-card-subtitle">Upload a new Form</mat-card-subtitle>
            </mat-card-header>
            <mat-card-content>
                <p>
                    Import a new SproutScribe form into your account.
                </p>
            </mat-card-content>
        </mat-card>
    </mat-grid-tile>
    <mat-grid-tile>
        <mat-card class="home-card" [routerLink]="'/design/forms'">
            <mat-card-header>
                <i mat-card-avatar class="icon-notebook"></i>
                <mat-card-title>Forms</mat-card-title>
                <mat-card-subtitle>Your Form List</mat-card-subtitle>
            </mat-card-header>
            <mat-card-content>
                <p>
                    View a listing of all the forms you have administrative access to.
                </p>
            </mat-card-content>
        </mat-card>
    </mat-grid-tile>
</mat-grid-list>